import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Smartphone, CheckCircle2, ArrowRight, Cloud, Database, Lock, Zap, Users, Code } from 'lucide-react';

const WebApps = () => {
  const features = [
    { icon: Cloud, title: 'Cloud-basiert', desc: 'Skalierbare Lösungen für wachsende Anforderungen' },
    { icon: Database, title: 'Datenbank-Integration', desc: 'Sichere Datenspeicherung und -verwaltung' },
    { icon: Lock, title: 'Sicherheit', desc: 'Höchste Sicherheitsstandards für Ihre Daten' },
    { icon: Users, title: 'Benutzerverwaltung', desc: 'Rollenbasierte Zugriffskontrolle' },
  ];

  const useCases = [
    { title: 'Kundenportale', desc: 'Self-Service für Ihre Kunden' },
    { title: 'Buchungssysteme', desc: 'Online-Terminverwaltung' },
    { title: 'Dashboards', desc: 'Datenvisualisierung in Echtzeit' },
    { title: 'Interne Tools', desc: 'Prozessoptimierung für Ihr Team' },
  ];

  return (
    <div>
      {/* Hero */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-slate-900 via-indigo-900 to-slate-900 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-20 right-20 w-64 h-64 bg-indigo-500/20 rounded-full blur-3xl" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-300 text-sm font-medium mb-6">
              <Smartphone size={16} />
              Web App Entwicklung
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
              Individuelle Web-Anwendungen
            </h1>
            <p className="text-xl text-slate-300 leading-relaxed mb-8">
              Maßgeschneiderte Webanwendungen, die Ihre Geschäftsprozesse digitalisieren und optimieren.
            </p>
            <Link to="/kontakt">
              <Button size="lg" className="bg-indigo-600 hover:bg-indigo-700 text-white">
                Projekt besprechen
                <ArrowRight className="ml-2" size={18} />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((f, i) => (
              <Card key={i} className="border-0 shadow-lg">
                <CardContent className="p-6 text-center">
                  <div className="w-14 h-14 rounded-xl bg-indigo-100 flex items-center justify-center mx-auto mb-4">
                    <f.icon className="text-indigo-600" size={28} />
                  </div>
                  <h3 className="font-semibold text-slate-900 mb-2">{f.title}</h3>
                  <p className="text-sm text-slate-600">{f.desc}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Use Cases */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-slate-900">Anwendungsbereiche</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {useCases.map((uc, i) => (
              <div key={i} className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                <h3 className="font-semibold text-slate-900 mb-2">{uc.title}</h3>
                <p className="text-slate-600 text-sm">{uc.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Info */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <Code className="text-indigo-600 mx-auto mb-4" size={48} />
          <h2 className="text-3xl font-bold text-slate-900 mb-4">Individuelle Kalkulation</h2>
          <p className="text-slate-600 mb-8">
            Jede Web-App ist einzigartig. Wir erstellen ein individuelles Angebot basierend auf Ihren Anforderungen. Typische Projekte starten ab 8.990€.
          </p>
          <Link to="/kontakt">
            <Button size="lg" className="bg-indigo-600 hover:bg-indigo-700 text-white">
              Kostenloses Erstgespräch
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default WebApps;
